// @ts-nocheck
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useClient } from '../../../../contexts/ClientContext';
import { AI_OPERATIONS_API_URL } from '../../../../services/config';
import {
  FiCheckCircle as CheckCircle, FiXCircle as XCircle, FiClock as Clock,
  FiShield as Shield, FiFileText as FileText, FiDatabase as Database, FiSettings as Settings,
  FiClipboard as ClipboardList, FiZap as Zap,
  FiDollarSign as DollarSign, FiSend as Rocket, FiLayers as Layers
} from 'react-icons/fi';
import AutoActionsTab from '../../../../features/settings/components/AutoActionsTab';
import ApprovalsContent from './governance/ApprovalsTab';
import ReleasesContent from './governance/ReleasesTab';
import AuditLogContent from './governance/AuditLogTab';
import EnvironmentsContent from './governance/EnvironmentsTab';
import PoliciesContent from './governance/PoliciesTab';
import CostsContent from './governance/CostsTab';

export const formatUserName = (userId) => {
  if (!userId) return 'System';

  if (userId.includes('@')) {
    return userId.split('@')[0];
  }

  if (userId.includes('-') && userId.length >= 32) {
    return userId.substring(0, 8) + '...';
  }

  return userId;
};

const TABS = [
  { id: 'environments', label: 'Environments', icon: Layers },
  { id: 'policies', label: 'Policies', icon: Settings },
  { id: 'approvals', label: 'Approvals', icon: Shield },
  { id: 'releases', label: 'Releases', icon: Rocket },
  { id: 'audit', label: 'Audit', icon: ClipboardList },
  { id: 'pbks', label: 'Auto-Actions', icon: Zap },
  { id: 'costs', label: 'Costs', icon: DollarSign }
];

export const StatusBadge = ({ status }) => {
  const statusConfig = {
    pending: { color: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300', icon: Clock },
    approved: { color: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300', icon: CheckCircle },
    rejected: { color: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300', icon: XCircle },
    expired: { color: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300', icon: Clock },
    cancelled: { color: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300', icon: XCircle }
  };

  const config = statusConfig[status] || statusConfig.pending;
  const Icon = config.icon;

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}>
      <Icon className="w-3 h-3 mr-1" />
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
};

export const ResourceIcon = ({ type }) => {
  const icons = { prompt: FileText, dataset: Database, agent_config: Settings };
  const Icon = icons[type] || FileText;
  return <Icon className="w-5 h-5" />;
};

export const ProjectBadge = ({ name }) => {
  if (!name) return null;
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300">
      {name}
    </span>
  );
};

const GovernancePage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { selectedClientId } = useClient();
  const activeTab = searchParams.get('tab') || 'environments';

  const handleTabChange = (tabId) => {
    setSearchParams({ tab: tabId });
  };

  return (
    <div className="mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white transition-colors">
          Governance
        </h1>
        <p className="mt-2 text-gray-600 dark:text-gray-400 transition-colors">
          Manage approvals, releases, audit logs, policies, and cost analytics
        </p>
      </div>

      <div className="mb-6 border-b border-gray-200 dark:border-gray-700">
        <nav className="-mb-px flex space-x-8">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => handleTabChange(tab.id)}
                className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors flex items-center gap-2 ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300'
                }`}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>

      {activeTab === 'environments' && <EnvironmentsContent />}
      {activeTab === 'approvals' && <ApprovalsContent />}
      {activeTab === 'releases' && <ReleasesContent />}
      {activeTab === 'audit' && <AuditLogContent />}
      {activeTab === 'policies' && <PoliciesContent />}
      {activeTab === 'pbks' && (
        <AutoActionsTab
          apiBaseUrl={AI_OPERATIONS_API_URL.replace(/\/v1$/, '')}
          clientId={selectedClientId}
        />
      )}
      {activeTab === 'costs' && <CostsContent />}
    </div>
  );
};

export default GovernancePage;
